import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-chatroom-message',
    templateUrl: './chatroom-message.component.html',
    styleUrls: ['./chatroom-message.component.scss'],
    standalone: false
})
export class ChatroomMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
